// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";

// // Define a central color palette for better consistency
// const colors = {
//     primary: '#007bff', // Blue for buttons/accents
//     secondary: '#6c757d', // Gray for text
//     success: '#28a745', // Green for success/wins
//     background: '#f8f9fa', // Light gray background
//     card: '#ffffff', // White card background
//     border: '#dee2e6', // Light border
//     shadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
// };

// function UserDetails() {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const apiBase = process.env.REACT_APP_SERVER_URL;

//     const [user, setUser] = useState(null);
//     const [winnings, setWinnings] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const userRes = await axios.get(`${apiBase}/api/users/${id}`);
//                 setUser(userRes.data);

//                 const winRes = await axios.get(`${apiBase}/api/win/${id}`);
//                 setWinnings(winRes.data);
//             } catch (err) {
//                 console.error("Error fetching user details:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [id, apiBase]);

//     if (loading) return <p style={{ padding: '20px', textAlign: 'center', color: colors.secondary }}>Loading...</p>;
//     if (!user) return <p style={{ padding: '20px', textAlign: 'center', color: colors.secondary }}>User not found</p>;

//     return (
//         <div style={{
//             padding: "20px",
//             backgroundColor: colors.background,
//             minHeight: '100vh'
//         }}>

//             {/* Back Button */}
//             <button
//                 // Using inline styles for a clean, modern button look
//                 onClick={() => navigate(-1)}
//                 style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     marginBottom: "30px",
//                     padding: '10px 15px',
//                     borderRadius: '8px',
//                     border: '1px solid',
//                     borderColor: colors.border,
//                     backgroundColor: colors.card,
//                     color: colors.secondary,
//                     cursor: 'pointer',
//                     fontSize: '1em',
//                     fontWeight: '600',
//                     transition: 'background-color 0.2s',
//                     boxShadow: colors.shadow
//                 }}
//                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = colors.border}
//                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = colors.card}
//             >
//                 <span style={{ fontSize: '1.2em' }}>&larr;</span> Back
//             </button>

//             {/* Title */}
//             <h1 style={{ marginBottom: "30px", fontSize: '2.5em', color: '#343a40' }}>
//                 <span style={{ color: colors.primary }}>{user.name}</span> Details
//             </h1>

//             {/* --- User Details Card --- */}
//             <div
//                 style={{
//                     marginBottom: "40px",
//                     backgroundColor: colors.card,
//                     padding: '30px',
//                     borderRadius: '12px',
//                     boxShadow: colors.shadow,
//                     border: `1px solid ${colors.border}`
//                 }}
//             >
//                 <h2 style={{ borderBottom: `2px solid ${colors.border}`, paddingBottom: '10px', marginBottom: '20px', color: '#495057' }}>
//                     Account Information
//                 </h2>

//                 {/* Detail Grid */}
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
//                     {/* Helper component for clean detail display */}
//                     {[
//                         { label: "Name", value: user.name },
//                         { label: "Email", value: user.email },
//                         { label: "Phone", value: user.phone },
//                         { label: "Role", value: user.role }
//                     ].map((item) => (
//                         <div key={item.label}>
//                             <p style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: colors.secondary, fontWeight: '500' }}>
//                                 {item.label}:
//                             </p>
//                             <p style={{ margin: 0, fontSize: '1.1em', fontWeight: '700', color: '#212529' }}>
//                                 {item.value}
//                             </p>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             {/* --- Winnings Section --- */}
//             <div
//                 style={{
//                     backgroundColor: colors.card,
//                     padding: '30px',
//                     borderRadius: '12px',
//                     boxShadow: colors.shadow,
//                     border: `1px solid ${colors.border}`
//                 }}
//             >
//                 <h2 style={{ borderBottom: `2px solid ${colors.border}`, paddingBottom: '10px', marginBottom: '20px', color: '#495057' }}>
//                     Winnings History
//                 </h2>

//                 {winnings.length === 0 ? (
//                     <p style={{ color: colors.secondary, fontStyle: 'italic' }}>This user has no recorded winnings yet.</p>
//                 ) : (
//                     // Using a standard HTML table with enhanced inline styles
//                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                         <thead style={{ backgroundColor: colors.primary, color: colors.card }}>
//                             <tr>
//                                 <th style={tableHeaderStyle}>Series</th>
//                                 <th style={tableHeaderStyle}>Quantity</th>
//                                 <th style={tableHeaderStyle}>Points</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {winnings.map((w, index) => (
//                                 <tr
//                                     key={w.id}
//                                     style={{
//                                         backgroundColor: index % 2 === 0 ? '#f8f9fa' : colors.card,
//                                         borderBottom: `1px solid ${colors.border}`
//                                     }}
//                                 >
//                                     <td style={tableCellStyle}>{w.series_name}</td>
//                                     <td style={tableCellStyle}>{w.quantity}</td>
//                                     <td style={{ ...tableCellStyle, fontWeight: 'bold', color: colors.success }}>{w.amount}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>
//         </div>
//     );
// }

// // Reusable styles for the table (keeping them outside the component for cleanliness)
// const tableHeaderStyle = {
//     padding: '12px 15px',
//     textAlign: 'left',
//     fontWeight: '700',
//     fontSize: '1em',
// };

// const tableCellStyle = {
//     padding: '12px 15px',
//     textAlign: 'left',
//     fontSize: '0.95em',
//     color: '#343a40'
// };

// export default UserDetails;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

// Define a central color palette
const colors = {
    primary: '#007bff',
    secondary: '#6c757d',
    success: '#28a745',
    background: '#f8f9fa',
    card: '#ffffff',
    border: '#dee2e6',
    shadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
};

function UserDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const apiBase = process.env.REACT_APP_SERVER_URL;

    const [user, setUser] = useState(null);
    const [winnings, setWinnings] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // State for feedback animations
    const [pageCopySuccess, setPageCopySuccess] = useState(false);
    const [codeCopySuccess, setCodeCopySuccess] = useState(false);

    useEffect(() => {
    const fetchData = async () => {
        try {
            const userRes = await axios.get(`${apiBase}/api/users/${id}`);
            setUser(userRes.data);

            const winRes = await axios.get(`${apiBase}/api/win/${id}`);
            
            // --- FILTER LOGIC START ---
            const now = new Date();

            const filteredWinnings = winRes.data.filter(w => {
                // 1. Create a Date object for the draw date
                const drawDateTime = new Date(w.draw_date);
                
                // 2. Parse the slot time (e.g., "10:30 AM") and set it on the drawDate
                // This helper handles both "14:00" and "02:00 PM" formats
                const [time, modifier] = w.slot.split(' ');
                let [hours, minutes] = time.split(':');
                
                if (hours === '12') hours = '00';
                if (modifier === 'PM') hours = parseInt(hours, 10) + 12;
                
                drawDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

                // 3. Only return true if the drawDateTime is in the past
                return drawDateTime <= now;
            });
            // --- FILTER LOGIC END ---

            setWinnings(filteredWinnings);
        } catch (err) {
            console.error("Error fetching user details:", err);
        } finally {
            setLoading(false);
        }
    };
    fetchData();
}, [id, apiBase]);

    // 1. Copy entire page URL (Top Right Button)
    const handleCopyPageLink = () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
            setPageCopySuccess(true);
            setTimeout(() => setPageCopySuccess(false), 2000);
        });
    };

    // 2. Copy specific Referral Code (Icon Button)
    const handleCopyReferralCode = () => {
        if (user && user.referral_code) {
            navigator.clipboard.writeText(user.referral_code).then(() => {
                setCodeCopySuccess(true);
                setTimeout(() => setCodeCopySuccess(false), 2000);
            });
        }
    };

    if (loading) return <p style={{ padding: '20px', textAlign: 'center' }}>Loading...</p>;
    if (!user) return <p style={{ padding: '20px', textAlign: 'center' }}>User not found</p>;

    return (
        <div style={{ padding: "20px", backgroundColor: colors.background, minHeight: '100vh', position: 'relative' }}>

            

            {/* Back Button */}
            <button
                onClick={() => navigate(-1)}
                style={{
                    display: "flex", alignItems: "center", gap: "8px", marginBottom: "30px",
                    padding: '10px 15px', borderRadius: '8px', border: '1px solid', borderColor: colors.border,
                    backgroundColor: colors.card, color: colors.secondary, cursor: 'pointer', fontWeight: '600',
                    boxShadow: colors.shadow
                }}
            >
                <span>&larr;</span> Back
            </button>

            {/* Title */}
            <h1 style={{ marginBottom: "30px", fontSize: '2.5em', color: '#343a40' }}>
                <span style={{ color: colors.primary }}>{user.name}</span> Details
            </h1>

            {/* --- User Details Card --- */}
            <div style={{ marginBottom: "40px", backgroundColor: colors.card, padding: '30px', borderRadius: '12px', boxShadow: colors.shadow, border: `1px solid ${colors.border}` }}>
                <h2 style={{ borderBottom: `2px solid ${colors.border}`, paddingBottom: '10px', marginBottom: '20px', color: '#495057' }}>
                    Account Information
                </h2>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                    
                    {/* Standard Fields */}
                    <DetailItem label="Name" value={user.name} />
                    <DetailItem label="Email" value={user.email} />
                    <DetailItem label="Phone" value={user.phone} />
                    <DetailItem label="Role" value={user.role} />
                    <DetailItem label="Points" value={user.points || '0.00'} />

                    {/* --- REFERRAL CODE WITH COPY ICON --- */}
                    <div>
                        <p style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: colors.secondary, fontWeight: '500' }}>
                            Referral Code:
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <p style={{ margin: 0, fontSize: '1.2em', fontWeight: '700', color: colors.primary, letterSpacing: '1px' }}>
                                {user.referral_code || 'N/A'}
                            </p>
                            
                            {/* The Copy Icon Button */}
                            {user.referral_code && (
                                <button
                                    onClick={handleCopyReferralCode}
                                    title="Copy Code"
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '4px',
                                        color: codeCopySuccess ? colors.success : colors.secondary,
                                        transition: 'color 0.2s',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    {codeCopySuccess ? (
                                        // Checkmark Icon
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    ) : (
                                        // Clipboard Icon
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                        </svg>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>

                </div>
            </div>

            {/* --- Winnings Section --- */}
            <div style={{ 
    backgroundColor: colors.card, 
    padding: '30px', 
    borderRadius: '12px', 
    boxShadow: colors.shadow, 
    border: `1px solid ${colors.border}`,
    height: '450px', // Fixed height
    display: 'flex',
    flexDirection: 'column'
}}>
    <h2 style={{ borderBottom: `2px solid ${colors.border}`, paddingBottom: '10px', marginBottom: '20px', color: '#495057' }}>
        Winnings History
    </h2>

    {winnings.length === 0 ? (
        <p style={{ color: colors.secondary }}>No winnings recorded.</p>
    ) : (
        <div style={{ overflowY: 'auto', flex: 1 }}> {/* Scrollable wrapper */}
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ backgroundColor: colors.primary, color: colors.card, position: 'sticky', top: 0 }}>
                    <tr>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Date</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Slot</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Series</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Quantity</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Points</th>
                    </tr>
                </thead>
                <tbody>
                    {winnings.map((w, i) => (
                        <tr key={w.id || i} style={{ backgroundColor: i % 2 === 0 ? '#f8f9fa' : 'white', borderBottom: `1px solid ${colors.border}` }}>
                            <td style={{ padding: '12px' }}>
                                {new Date(w.draw_date).toLocaleDateString()}
                            </td>
                            <td style={{ padding: '12px' }}>{w.slot}</td>
                            <td style={{ padding: '12px' }}>{w.series_name}</td>
                            <td style={{ padding: '12px' }}>{w.quantity}</td>
                            <td style={{ padding: '12px', color: colors.success, fontWeight: 'bold' }}>
                                {w.amount}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )}
</div>
        </div>
    );
}

// Simple helper component for standard details
const DetailItem = ({ label, value }) => (
    <div>
        <p style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#6c757d', fontWeight: '500' }}>{label}:</p>
        <p style={{ margin: 0, fontSize: '1.1em', fontWeight: '700', color: '#212529' }}>{value}</p>
    </div>
);

export default UserDetails;